import LoadingSkeletonContainer from 'ComponentLibrary/src/atoms/LoadingSkeleton/LoadingSkeletonContainer'
import { Stack } from '@mui/material'

export function TaskHeaderLoader() {
    return (
        <Stack width="100%" flexDirection="row">
            <LoadingSkeletonContainer loadersPattern={[{ count: 1, height: '32px' }]} justifyContent="flex-start" />
        </Stack>
    )
}
